export const CONSTANTES = {
  MINZOOM: 8.5,
  DELITACAO: {
    REGIONAL: 1,
    MUNICIPAL: 2,
  },
};
